import { useRouter } from "next/router";

export function useLocaleRedirect(target?: string | null) {
  const router = useRouter();
  const current = router.locale;

  if (!target || target === current) return;

  router.replace(router.asPath, router.asPath, { locale: target });
}
